import $ from 'jquery'

const TRIGGER_SELECTOR = '.article__author--more'
const CONTENT_SELECTOR = '.article__author--hide'
const ACTIVE_CLASS = 'article__author--show'

class Article {
  constructor(item) {
    this.item = $(item)
    this.trigger = $(TRIGGER_SELECTOR, item)
    this.content = $(CONTENT_SELECTOR, item)

    this.listen()
  }

  listen() {
    this.trigger.on('click', () => {
      event.preventDefault()
      this.activate()
    })
  }

  activate() {
    this.content.addClass(ACTIVE_CLASS)
    this.trigger.hide()
  }
}

export default Article
